export default __webpack_public_path__ + "static/koiwa1chu-dc5679978116d2cd84c2cea09ff17818.jpg";